import { render, staticRenderFns } from "./InterimBox.vue?vue&type=template&id=5d9f0709&"
import script from "./InterimBox.vue?vue&type=script&lang=js&"
export * from "./InterimBox.vue?vue&type=script&lang=js&"
import style0 from "./InterimBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports